module.exports = __webpack_public_path__ + "img/four-pucks.acf13272.png";